module.exports = __webpack_public_path__ + "img/nets.7586428a.svg";